// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/51573703-f3df-4683-9185-f9a80b4373f7/js/" + ({"653":"videojs","818":"theoplayer"}[chunkId] || chunkId) + "." + {"653":"2d9dca9f","787":"1d6fadfa","818":"13832512","829":"87e89aa2"}[chunkId] + ".chunk.js";
};